module.exports = __webpack_public_path__ + "img/inbox-out.e2f9a63a.svg";